import { NetworkInstructionHistoryClient } from "../../../../Wrap/Api/Network/NetworkInstructionHistory";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { NetworkInstructionDispatcher, NetworkWizardDispatcher, NetworkDispatcher } from "../Stores/Variable";
import { NetworkInstructionClient } from "../../../../Wrap/Api/Network/NetworkInstruction";
import { NetworkInstructionModel } from "../../../../Wrap/Models/Models/Network/NetworkInstructionModel";
import { NetworkHistoryClient } from "../../../../Wrap/Api/Network/NetworkHistory";

export class NetworkAction {
    public static getNetworkList(query): void {
        const client = new NetworkInstructionHistoryClient();
        const promise = client.get(
            query.Statuses,
            query.NetworkType,
            query.NetworkName,
            query.TradingReference,
            query.CreateUserId,
            query.StartedFromDate,
            query.StartedToDate,
            query.UpdatedFromDate,
            query.UpdatedToDate,
            query.NetworkProcessType,
            query.Count,
            query.Start
        );
        promise.onSuccess((data) => {
            NetworkInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static deleteNetworkList(query: number[], callback?: () => void): void {
        const client = new NetworkInstructionClient();
        const promise = client.delete(query);
        promise.onSuccess((data) => {
            if (data.length == 0) {
                NetworkInstructionDispatcher.dispatch({
                    actionType: ActionType.Update,
                });
            } else {
                NetworkInstructionDispatcher.dispatch({
                    actionType: ActionType.Error,
                });
            }
            callback();
        });

        promise.onError((err) => {
            NetworkInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getNetwork(query: any, callback?) {
        const client = new NetworkHistoryClient();
        const promise = client.get(
            query.NetworkId,
            query.NetworkType,
            query.NetworkName,
            query.TradingReference,
            query.PostCode,
            false,
            query.Max,
            query.Min
        );
        promise.onSuccess((data) => {
            NetworkDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback(data);}
        });
        promise.onError((err) => {
            NetworkDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getNetworkInstruction(id: string | number) {
        const client = new NetworkInstructionClient();
        const promise = client.get(Number(id));
        promise.onSuccess((data) => {
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static updateNetworkInstruction(data: NetworkInstructionModel, callback?) {
        const client = new NetworkInstructionClient();
        const promise = client.put(data);
        promise.onSuccess((data) => {
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
            if (callback) {callback();}
        });

        promise.onError((err) => {
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submit(data: NetworkInstructionModel, onSuccess?: () => void): void {
        const client = new NetworkInstructionClient();
        const promise = client.put(data);
        promise.onSuccess(() => onSuccess());
    }

    public static createNetworkInstruction(data: NetworkInstructionModel, callback?) {
        const client = new NetworkInstructionClient();
        const promise = client.post(data);
        promise.onSuccess((data) => {
            NetworkDispatcher.dispatch({ actionType: ActionType.Success, payload: null });
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback(data);}
        });

        promise.onError((err) => {
            NetworkWizardDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
